export {useTypeSelect, type AriaTypeSelectOptions, type TypeSelectAria} from '../../../src/selection/useTypeSelect';
